/* Zoci collection page (sections/zoci-collection.liquid). Everything here is an enhancement:
   without JS the page still filters, sorts and paginates through plain links and a form. */
(function () {
  var root = document.querySelector('[data-zcl]');
  if (!root) return;
  var SEEN = 'zoci_seen';

  function read(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }

  // 1. Greeting: "Welcome back" with the last pieces viewed, otherwise the time of day.
  var hello = root.querySelector('[data-zcl-hello]');
  var seen = read(SEEN) || [];
  if (hello) {
    var hr = new Date().getHours();
    hello.textContent = seen.length ? 'Welcome back' : hr < 12 ? 'Good morning' : hr < 17 ? 'Good afternoon' : 'Good evening';
  }
  var resume = root.querySelector('[data-zcl-resume]');
  if (resume && seen.length && seen[0].u) {
    resume.href = seen[0].u;
    resume.querySelector('[data-zcl-resume-title]').textContent = seen[0].t || 'your last piece';
    var pics = resume.querySelector('[data-zcl-resume-pics]');
    seen.slice(0, 3).forEach(function (s) {
      if (!s.i) return;
      var img = document.createElement('img');
      img.src = s.i; img.alt = ''; img.width = 28; img.height = 28; img.loading = 'lazy';
      pics.appendChild(img);
    });
    resume.hidden = false;
  }

  // 2. Sort: apply on change.
  var sort = root.querySelector('[data-zcl-sort]');
  if (sort) sort.addEventListener('change', function () { sort.requestSubmit ? sort.requestSubmit() : sort.submit(); });

  // Phones: the current bubble and price chip may sit past the right edge of their scroll row; bring them in.
  root.querySelectorAll('.zcl__cat[aria-current], .zcl__chip[aria-current]').forEach(function (el) {
    var row = el.parentElement;
    while (row && row !== root && !/auto|scroll/.test(getComputedStyle(row).overflowX)) row = row.parentElement;
    if (!row || row === root) return;
    var r = el.getBoundingClientRect(), rr = row.getBoundingClientRect();
    if (r.right > rr.right - 8) row.scrollLeft += r.left - rr.left - (rr.width - r.width) / 2;
  });

  // 3. Category bubbles: the tapped photo becomes the next page's header photo (cross-document view transition).
  root.querySelectorAll('[data-zcl-cat]').forEach(function (a) {
    a.addEventListener('click', function () {
      root.querySelectorAll('.zcl__cat-pic img').forEach(function (i) { i.style.viewTransitionName = ''; });
      var av = root.querySelector('.zcl__avatar-img');
      if (av) av.style.viewTransitionName = 'none';
      var img = a.querySelector('img');
      if (img) img.style.viewTransitionName = 'zcl-avatar';
      a.classList.add('is-going');
    });
  });
  window.addEventListener('pageshow', function () {
    root.querySelectorAll('.is-going').forEach(function (a) { a.classList.remove('is-going'); });
    root.querySelectorAll('.zcl__cat-pic img').forEach(function (i) { i.style.viewTransitionName = ''; });
    var av = root.querySelector('.zcl__avatar-img');
    if (av) av.style.viewTransitionName = '';
  });

  // 4. Show more: fetch the next page of this section and append its cards.
  var more = root.querySelector('[data-zcl-more]');
  function bindMore() {
    var next = more && more.querySelector('[data-zcl-next]');
    if (!next) return;
    next.addEventListener('click', function (e) {
      e.preventDefault();
      if (next.classList.contains('is-loading')) return;
      next.classList.add('is-loading'); next.setAttribute('aria-busy', 'true'); next.textContent = 'Loading';
      var sectionId = root.closest('.shopify-section').id.replace('shopify-section-', '');
      var url = next.href + (next.href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-zcl-grid]');
        var firstNew = null;
        doc.querySelectorAll('[data-zcl-grid] > .zoci-card').forEach(function (card) {
          var node = document.importNode(card, true);
          node.classList.add('is-new');
          grid.appendChild(node);
          if (!firstNew) firstNew = node;
        });
        var newMore = doc.querySelector('[data-zcl-more]');
        if (newMore) { more.innerHTML = newMore.innerHTML; bindMore(); }
        var link = firstNew && firstNew.querySelector('.zoci-card__title');
        if (link) link.focus({ preventScroll: true });
      }).catch(function () { window.location.href = next.href; });
    });
  }
  bindMore();

  // 5. Save hearts: keyboard support and a real pressed state for screen readers.
  function syncHearts() {
    root.querySelectorAll('.zoci-card__save').forEach(function (b) {
      b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false');
    });
  }
  root.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('.zoci-card__save');
    if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); b.click(); }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.zoci-card__save')) setTimeout(syncHearts, 0);
  });
  syncHearts();
})();
